import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { Wrapper, Logo, LogoImg } from "./styled"

const Communities = () => {
  const { logoImage, logoDev, willianJusten } = useStaticQuery(graphql`
    query {
      logoImage: file(relativePath: { eq: "rocketseat.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      logoDev: file(relativePath: { eq: "devPleno.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      willianJusten: file(relativePath: { eq: "wj.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Wrapper>
      <Logo
        title="Rocketseat"
        href="https://rocketseat.com.br/"
        target="_blank"
      >
        <LogoImg
          objectFit="none"
          fluid={logoImage.childImageSharp.fluid}
          alt="Rocketseat Logo"
        />
      </Logo>
      <Logo title="devPleno" href="https://devpleno.com/" target="_blank">
        <LogoImg
          objectFit="none"
          fluid={logoDev.childImageSharp.fluid}
          alt="devPleno Logo"
        />
      </Logo>
      <Logo
        title="Willian Justen"
        href="https://willianjusten.com.br/"
        target="_blank"
      >
        <LogoImg
          objectFit="none"
          fluid={willianJusten.childImageSharp.fluid}
          alt="coday"
        />
      </Logo>
    </Wrapper>
  )
}
export default Communities
